import React from "react";

import { Switch, Route } from "react-router-dom";
import FinanceProfile from "./FinanceProfile";

const Routes = () => {
  const basePath = "/mis";
  return (
    <Switch>
      <Route
        path={`${basePath}/contractor/:cid/profile/finance`}
        render={(p) => <FinanceProfile {...p} />}
      />
    </Switch>
  );
};

export default Routes;
